import axios from 'axios';
import DOMPurify from 'dompurify';
import moment from 'moment-timezone';

export const getSearcData = (payload) => {
	return axios.post(`/api/get-search-res`, payload);
};

export const getEventDetails = (payload) => {
	return axios.post(`/api/get-event-details`, payload);
};

export const retryForwarding = (payload) => {
	return axios.post(`/api/retry-forwarding`, payload);
};

export const getAllSuggestions = (payload) => {
	return axios.post(`/api/get-all-values`, payload);
};

export const REDACTION_API = (payload, cancelApiToken) => {
	return axios.post(`/api/redaction-mask`, payload, cancelApiToken);
};

export const GET_ELASTIC_RECORDS_API = () => {
	return axios.get(`/api/get-peg-metrics`);
};

export const GET_PREDEFINED_REGEX_API = () => {
	return axios.get(`/api/getPredefinedRegex`);
};

// Validate and sanitize fileName and bucketName
export const sanitizeInput = (input) => {
	// Allow only alphanumeric characters, underscores, dashes, and dots
	return input.replace(/[^a-zA-Z0-9._-]/g, '');
};

export const GET_PRESIGNED_URL = (payload) => {
	const fileName = payload.fileName;
	const bucketName = payload.bucketName;
	const url = `/api/get-minio-preSignedURL?fileName=${DOMPurify.sanitize(fileName)}&bucketName=${DOMPurify.sanitize(bucketName)}`;
	return axios.get(url);
};

export const CREATE_SCOPING_CRON_JOB = async () => {
	try {
		// create scoping cron job
		await axios.get(`/api/create-scoping-cronjob`);
	} catch (error) {
		console.error('Error while creating scoping cron:', error);
	}
};

export const getTimestamp = () => {
	return moment().format(`YYYY-MM-DDTHH:mm:ss`);
};

export const getDateWithTimezone = () => {
	return moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};

export const SAVE_AUDIT_LOGS = async ({
	action,
	newValues,
	previousValues,
	configType,
	username,
}) => {
	try {
		await axios.post('/api/audit-log', {
			new_values: newValues ? JSON.stringify(newValues) : null,
			previous_values: previousValues ? JSON.stringify(previousValues) : null,
			config_type: configType,
			action,
			created_at: getDateWithTimezone(),
			created_by: username,
			'@timestamp': getDateWithTimezone(),
			version: 1,
		});
	} catch (error) {
		console.error('Error while creating scoping cron:', error);
	}
};
